// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"App_sectionWrapper__Z5WTr"};